import React from "react";
import ReactSelect from "react-select";

export const Select = ({
  name,
  placeholder,
  value,
  onChange,
  options,
}) => (
  <ReactSelect
    styles={{
      valueContainer: () => ({
        width: 250,
      }),
    }}
    className="react-select primary"
    classNamePrefix="react-select"
    name="itemSelected"
    value={value}
    onChange={newValue => onChange(name, newValue)}
    options={options}
    placeholder={placeholder}
  />
);

